// extracted by mini-css-extract-plugin
export const atlasGrotesk = "'AtlasGrotesk'";
export const autosuggest = "OldSelect__autosuggest__Jd83o";
export const bold = "700";
export const clearInput = "OldSelect__clearInput__seEYC";
export const dark = "OldSelect__dark__SekDV";
export const dropdownItems = "OldSelect__dropdownItems__bZ7+3";
export const headBgColorExternal = "var(--salt)";
export const headBgColorInternal = "var(--shade)";
export const headBgColorShrunkSidebar = "var(--slate)";
export const isAboveInput = "OldSelect__isAboveInput__qj-eP";
export const isDisabled = "OldSelect__isDisabled__gFjB9";
export const isDropdownShown = "OldSelect__isDropdownShown__LOFOd";
export const isFirefox = "OldSelect__isFirefox__EiJDR";
export const isLoading = "OldSelect__isLoading__fALeN";
export const item = "OldSelect__item__mjVV8";
export const itemHighlighted = "OldSelect__itemHighlighted__vsKWt";
export const items = "OldSelect__items__DclK7";
export const medium = "500";
export const noResults = "OldSelect__noResults__AZ+fr";
export const regular = "400";
export const roundFrame = "OldSelect__roundFrame__nNO8P";
export const sans = "'sans'";
export const searchTextboxIcon = "OldSelect__searchTextboxIcon__aqMQm";
export const select = "OldSelect__select__ye7e9";
export const semibold = "600";
export const serif = "'serif'";
export const textCenter = "OldSelect__textCenter__ilkT1";
export const withBorder = "OldSelect__withBorder__-UnSs";